import { createMemo } from "solid-js";
import { SpeechButton } from "~/components/Buttons/SpeechButton";
import { isAuthenticated } from "~/stores/auth";
import { useDocumentContext } from "../../../providers/context";

export function DocumentSpeechButton() {
	const { selected } = useDocumentContext();

	const contentInText = createMemo(() => {
		const _selected = selected();

		if (!_selected) {
			return "";
		}

		return [_selected.breadcrumb, _selected.tocTitle, _selected.content].join(".");
	});

	return (
		<SpeechButton
			value={contentInText()}
			disabled={!isAuthenticated() && selected()?.isProtected}
		/>
	);
}
